'use client'

import { PortableText, type PortableTextBlock } from '@portabletext/react'
import { portableTextComponents } from './PortableTextComponents'
import { Prose } from '../Prose'

export type StepItem = {
  title: string
  content: PortableTextBlock[]
}

export type StepGroupProps = {
  steps: StepItem[]
}

const StepGroup = ({ value }: { value: StepGroupProps }): JSX.Element => {
  const { steps = [] } = value

  if (!steps.length) return <></>

  return (
    <div className="prose my-8 !min-w-full">
      <div className="relative w-full">
        {steps.map((step, index) => (
          <div key={index} className="relative mb-0 flex w-full last:mb-0">
            {/* Vertical line connecting steps */}
            {index < steps.length - 1 && (
              <div className="absolute left-[14px] top-9 h-[calc(100%-2.7rem)] w-px -translate-x-1/2 bg-slate-600" />
            )}

            {/* Last vertical line with gradient */}
            {index === steps.length - 1 && index > 0 && (
              <div className="absolute left-[14px] top-9 h-[calc(100%-2.7rem)] w-px -translate-x-1/2 bg-gradient-to-b from-slate-600 to-[70%] to-transparent" />
            )}

            {/* Step number badge */}
            <div className="mr-[34px] flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-slate-700 text-sm font-semibold text-white">
              {index + 1}
            </div>

            {/* Step content */}
            <div className="w-full flex-1">
              <h3 className="mb-5 mt-0 text-lg font-bold leading-7 text-white">
                {step.title}
              </h3>
              <div className="w-full pb-9 text-slate-300">
                <Prose className="!w-full font-sans">
                  <PortableText
                    value={step.content}
                    components={portableTextComponents}
                  />
                </Prose>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StepGroup
